import { render, staticRenderFns } from "./WordWheel.vue?vue&type=template&id=3c8e8938&scoped=true&"
import script from "./WordWheel.vue?vue&type=script&lang=js&"
export * from "./WordWheel.vue?vue&type=script&lang=js&"
import style0 from "./WordWheel.vue?vue&type=style&index=0&id=3c8e8938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e8938",
  null
  
)

component.options.__file = "WordWheel.vue"
export default component.exports